import Portal from 'components/Portal';
import React, { FC } from 'react';

const ApplicationTitleAppendix: FC = ({ children }) => {
  return <Portal domId="titleExtraInformation">{children}</Portal>;
};

export default ApplicationTitleAppendix;
